import getCalendarFoldersOperation from 'owa-service/lib/operation/getCalendarFoldersOperation';
import GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export const getCalendarFoldersService = async (): Promise<GetCalendarFoldersResponse> =>
    await getCalendarFoldersOperation({ Header: getJsonRequestHeader() });
